import initHeader from '../_modules/header/index'
import { revealLinksOnAction, setTimezone } from '../_modules/helpers'
import { initVideos } from './video-reviews/index'
import { initMoreReviews } from './more-reviews/index'
import { initComment } from './comment/index'
import { initLatestReviews } from './latest-reviews/index'
import workerHandler from "./workerHandler";
import { handleRefsUs, REFS_US } from '@studybay/common-client-library/ref-handle';
import { FirstTouchTracking } from '@studybay/common-client-library/first-touch-tracking';
import { forbidCopyingContent, eventContentProtected } from '@studybay/common-client-library/content-protectors'
import { getCookie } from '@studybay/common-client-library/cookie'

workerHandler.init()
initHeader()
initVideos()
initMoreReviews()
initComment()
initLatestReviews()
setTimezone()
revealLinksOnAction(() => {
    handleRefsUs(REFS_US.SEO_US_REVIEWS)
    FirstTouchTracking()
})

// related to base coontent protection here; application/views/outerPages/reviewsPage/index.twig
if (getCookie('__acpc')) {
    window.dispatchEvent(eventContentProtected())
} else {
    forbidCopyingContent('main')
}
